/** Viewer-timezone display with the authoritative UTC time on hover (NFR-06). */
const fmt = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});
const fmtDate = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', year: 'numeric' });

export function Timestamp({
  value,
  dateOnly,
  relative,
}: {
  value: string | Date | null | undefined;
  dateOnly?: boolean;
  relative?: boolean;
}) {
  if (!value) return <span className="muted">—</span>;
  const d = typeof value === 'string' ? new Date(value) : value;
  const utc = d
    .toISOString()
    .replace('T', ' ')
    .replace(/\.\d+Z$/, ' UTC');
  return (
    <time dateTime={d.toISOString()} title={utc}>
      {relative ? age(d) : dateOnly ? fmtDate.format(d) : fmt.format(d)}
    </time>
  );
}

export function age(d: Date | string, now = new Date()): string {
  const t = typeof d === 'string' ? new Date(d) : d;
  const mins = Math.max(0, Math.round((now.getTime() - t.getTime()) / 60_000));
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 48) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}

export const shortAge = (d: Date | string) => age(d).replace(' ago', '');
